import React from 'react';
import Layout from '../layout';
import { withLocalize } from "react-localize-redux";
import ajaxService from '../services/ajax-service';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/auth-context';
import { setToken, setUser } from '../redux/actions';
import { Form, Input, Button, Toast } from 'antd-mobile';
import { useDispatch } from 'react-redux';


const Login = ({ translate }) => {

    const router = useHistory();
    const [, setLogin] = useAuth()
    const dispatch = useDispatch();

    // const onFinish = async (values) => {

    //     let response = await ajaxService.post('login', values);

    //     if (response != null) {

    //         let { token, user } = response.data;

    //         dispatch(setToken(token))
    //         dispatch(setUser(user))
    //         setLogin(true);
    //         router.push({ pathname: '/masjid-list' });
    //     }
    // }

    const onFinish = async (values) => {
        try {
            let response = await ajaxService.post('login', values);


            if (!response || response.status !== 200) {
                let message = response?.data?.message || "Password mismatch";

                Toast.show({
                    content: message,
                    duration: 2000,
                    position: 'top',
                });

                return;
            }

            if (response != null && response.data) {
                const { token, user } = response.data;

                dispatch(setToken(token));
                dispatch(setUser(user));
                setLogin(true);

                router.push({ pathname: '/masjid-list' });
            }
        } catch (error) {
            Toast.show({
                content: "An unexpected error occurred",
                duration: 2000,
                position: 'top',
            });
        }
    }


    return (
        <Layout title={translate('login')} >
            <div style={{ marginLeft: '30px', marginRight: '30px', height: document.body.clientHeight }}>

                <h2 style={{
                    textAlign: 'center',
                    marginBottom: '10px',
                    color: '#333',
                    fontWeight: 'bold'
                }}>
                    {translate('only_for_masjid_admin')}

                </h2>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                    <Form
                        onFinish={onFinish}
                        footer={
                            <Button block type='submit' color='primary' size='large'>
                                Submit
                            </Button>
                        }
                        mode="card"

                    >
                        <Form.Item
                            name='phone'
                            label='Phone'
                            rules={[{ required: true, message: 'Phone field is required' }]}
                        >
                            <Input placeholder='Phone' />
                        </Form.Item>
                        <Form.Item
                            name='password'
                            label='Password'
                            rules={[{ required: true, message: 'Password field is required' }]}
                        >
                            <Input placeholder='Password' type="password" />
                        </Form.Item>

                    </Form>
                </div>
            </div>
        </Layout>
    )

}

export default withLocalize(Login)